export class Parallax{
	init($sections){
		if ( $(window).width() > 1020) {
      $(window).scroll(function(){
        var wScrollTop = $(window).scrollTop();
        $('.cms-section[data-parallax="true"]').each(function(id, item){
          if($(this).visible(true)){
            var itemTop = $(this).offset().top;
            var s = wScrollTop - (itemTop);
            $(this).find('.s-background .s-background__img').css({
              'transform':'translateY(' + (s*0.15) +'px)',
              '-webkit-transform':'translateY(' + (s*0.15) +'px)',
              '-moz-transform':'translateY(' + (s*0.15) +'px)'
            });
          }
        });
      });
    }
	}
}